var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Telegram",
    d: "M29.8,2.6l-29,11.3c0,0,0,0-0.1,0c-0.2,0.1-1.9,1.1,0.4,2.1l0,0l6.9,2.3c0.1,0,0.2,0,0.3,0L25.6,7.4 c0,0,0.1,0,0.1-0.1c0.2,0,0.9-0.1,0.5,0.4C25.7,8.5,14,19,12.7,20.2c-0.1,0.1-0.1,0.2-0.1,0.3L12,27.3c0,0.1,0.1,0.3,0.2,0.4 c0.2,0.1,0.4,0.1,0.5,0l4.1-3.7c0.1-0.1,0.3-0.1,0.5,0l7.2,5.2l0,0c0.2,0.1,2,1.2,2.6-1.2L32,4.2c0-0.1,0.1-0.9-0.5-1.4 C30.8,2.3,30,2.5,29.8,2.6C29.8,2.6,29.8,2.6,29.8,2.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelegram);
export default __webpack_public_path__ + "static/media/icon-telegram.f1e667c51dbf3d78d4bbf9b71620d880.svg";
export { ForwardRef as ReactComponent };